import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../config/FirebaseConfig"; // db exported from your config

class UserApi {
    // '<' operator is used to filter based on less than
    // '<=' operator is used to filter based on less than or equal to
    // '==' operator is used to filter based on equal to
    // '>' operator is used to filter based on greater than
    // '>=' operator is used to filter based on greater than or equal to
    // '!=' operator is used to filter based on not equal to
    // 'array-contains' operator is used to filter based on array contains
    // 'array-contains-any' operator is used to filter based on array contains any
    // 'in' operator is used to filter based on in
    // 'not-in' operator is used to filter based on not in

    /*{
        role: "producer" | "consumer" | "admin",
        name: string,
        email: string,
        companyId: string | null,      // Only for producers in a company
        isActive: boolean,
        isDeleted: boolean,
        createdAt: timestamp,
        updatedAt: timestamp
    }*/

    async getUser(id = null) {
        if (!id) {
            console.error("Invalid user ID:", id);
            return { success: false, error: "Invalid user ID" };
        }
        try {
            const userDoc = await getDoc(doc(db, "users", id));
            if (userDoc.exists()) {
                return { success: true, user: userDoc.data() };
            } else {
                console.error("User not found:", id);
                return { success: false, error: "User not found" };
            }
        } catch (error) {
            console.error("Error fetching user:", error);
            return { success: false, error: error.message };
        }
    }

    async createUser(id = null, body = {}) {
        if (!id || !body || !body.name || !body.email) {
            console.error("Invalid user data:", { id, body });
            return { success: false, error: "Invalid user data" };
        }
        try {
            await setDoc(doc(db, "users", id),
                {
                    uid: id,
                    role: body.role || "producer",
                    name: body.name,
                    email: body.email,
                    companyId: body?.role === "producer" ? body.companyId || null : null,
                    isActive: true,
                    isDeleted: false,
                    createdAt: serverTimestamp(),
                    updatedAt: serverTimestamp(),
                }
            );

            return { success: true, userId: id }
        } catch (error) {
            console.error("Error creating user:", error);
            return { success: false, error: error.message };
        }
    }

    async updateUser(id = null, body = {}) {
        if (!id || !body) {
            console.error("Invalid user data:", { id, body });
            return { success: false, error: "Invalid user data" };
        }
        try {
            await setDoc(doc(db, "users", id), {
                ...body,
                updatedAt: serverTimestamp(),
            }, { merge: true });

            return { success: true };
        } catch (error) {
            console.error("Error updating user:", error);
            return { success: false, error: error.message };
        }
    }

}

export default UserApi;